"use client";

import { FormEvent, KeyboardEvent, useState } from "react";

type MessageInputProps = {
  disabled?: boolean;
  isSending?: boolean;
  onSend: (message: string) => void | Promise<void>;
};

export function MessageInput({ disabled, isSending, onSend }: MessageInputProps) {
  const [message, setMessage] = useState("");

  const submit = async () => {
    const payload = message.trim();
    if (!payload || disabled || isSending) {
      return;
    }
    await onSend(payload);
    setMessage("");
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await submit();
  };

  const handleKeyDown = async (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key !== "Enter" || event.shiftKey) {
      return;
    }
    event.preventDefault();
    await submit();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex w-full min-w-0 items-end gap-2 border-t border-slate-200 p-3 dark:border-slate-700"
    >
      <textarea
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        onKeyDown={handleKeyDown}
        rows={1}
        disabled={disabled || isSending}
        placeholder="Digite sua mensagem..."
        className="max-h-28 min-h-[44px] min-w-0 flex-1 resize-none overflow-y-auto rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200 disabled:cursor-not-allowed disabled:bg-slate-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:ring-emerald-900 dark:disabled:bg-slate-900"
      />
      <button
        type="submit"
        disabled={disabled || isSending || !message.trim()}
        className="inline-flex h-11 shrink-0 items-center rounded-xl bg-emerald-600 px-4 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-emerald-300"
      >
        {isSending ? "Enviando..." : "Enviar"}
      </button>
    </form>
  );
}
